import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class Products {
  static init() {
    const product = document.querySelectorAll('[data-js="product-swiper"]');

    product.forEach(element => {
      const slidesCount = element.querySelectorAll('.swiper-slide').length;
      const delaySpeed = element.dataset.speed;

      new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay],
        loop: true,
        slidesPerView: 4.5,
        breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 3
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 4
              }
          },
        autoplay: {
            delay: 7000,
        },
        pagination: {
            el: '.hero-pagination',
            horizontalClass: 'hero-pagination-horizontal',
            bulletClass: 'hero-pagination-bullet',
            bulletActiveClass: 'hero-pagination-bullet-active',
            clickable: true,
            clickableClass: 'hero-pagination-clickable',
            currentClass: 'hero-pagination-current'
        },
      });
    });

    }
}

export { Products };